if(!customElements.get('tag-price')){
    customElements.define('tag-price', class extends HTMLElement{
        constructor(){
            super();
            let discount_data_el = this.querySelector('[id^="tag-price--"]');
            this.value_el = this.querySelector('.tag-price__value')

            if(!discount_data_el || !this.value_el) return

            this.discount_data = JSON.parse(discount_data_el.innerHTML);

            if(!this.discount_data.discount) return

            document.body.addEventListener('variantChange', this.updatePrice.bind(this))

        }

        updatePrice(e){
            var current_variant = e.detail.currentVariant

            if(!current_variant) return

            let price = current_variant.price
            let discount_price = 0

            if(this.discount_data.discount.type == 'percent'){
                //get price via percentage
                discount_price = price - (price * (this.discount_data.discount.value / 100))
            } else {
                //get price via fixed amount
                discount_price = price - this.discount_data.discount.value
            }
            
            this.value_el.innerHTML = Shopify.formatMoney(discount_price)
        }
    });
}